import React from 'react';
import PageTabs from '../components/PageTabs';
import './Pages.scss';
import CombinedChart from "../Graphics/BySeasons/CombinedChart.jsx";
import ExcelGraph from "../Graphics/TragerCoefficientChart/TragerCoefficientChart.jsx";
import DynamicsContextCharts from "../Graphics/TragerCoefficientChart/DynamicsContextCharts.jsx";
import HistogramChart from '../Graphics/TimeSeries/HistogramChart.jsx';
import { useLocation, useNavigate } from 'react-router-dom';
import { PAGE_KEYS } from '../utils/pageAccess';

function DynamicsAnalysis({ allowedPages = [] }) {
  const location = useLocation();
  const navigate = useNavigate();

  // Карта путей для каждой вкладки
  const tabRouteMap = [
    { id: 'trager_dynamics', label: 'Динамика эмоциональной напряженности', route: '/', page: PAGE_KEYS.DYNAMICS },
    { id: 'context_charts', label: 'Авторы и активность', route: '/dynamics-context', page: PAGE_KEYS.DYNAMICS_CONTEXT },
    { id: 'season_index', label: 'Индекс сезонной эмоциональной напряженности', route: '/season-index', page: PAGE_KEYS.DYNAMICS_SEASON },
    { id: 'time_series', label: 'Временные ряды индекса эмоциональной напряженности', route: '/time-series', page: PAGE_KEYS.DYNAMICS_TIME_SERIES }
  ];

  const filteredTabs = tabRouteMap.filter(tab => allowedPages.includes(tab.page));

  // Определяем активный таб по текущему маршруту
  function getTabByPath(pathname) {
    if (pathname === '/' || pathname === '') return 'trager_dynamics';
    for (const tab of tabRouteMap) {
      if (tab.route === pathname) return tab.id;
    }
    // Фолбэк
    return 'trager_dynamics';
  }

  const activeTab = getTabByPath(location.pathname);

  // Если выбранный таб отличается от маршрута — переключаем путь при клике
  function handleTabChange(tabId) {
    const tab = tabRouteMap.find(t => t.id === tabId);
    if (tab) {
      navigate(tab.route);
    }
  }

  return (filteredTabs.length > 0 ? (
    <div className="top-level-page-container">
      <PageTabs
        activeTab={activeTab}
        setActiveTab={handleTabChange}
        tabs={filteredTabs.map(({id, label}) => ({ id, label }))}
      />
      <div className="page-content">
        {activeTab === 'season_index' && (
          <CombinedChart />
        )}
        {activeTab === 'trager_dynamics' && (
          <ExcelGraph />
        )}
        {activeTab === 'context_charts' && allowedPages.includes(PAGE_KEYS.DYNAMICS_CONTEXT) && (
          <DynamicsContextCharts />
        )}
        {activeTab === 'time_series' && (
          <HistogramChart />
        )}
      </div>
    </div>
  ) : (
    <div className="top-level-page-container">
      <h1>У вас нет доступа к этой странице</h1>
    </div>
  ));
}

export default DynamicsAnalysis;

